import classNames from 'classnames';
import React from 'react';
import { Wrapper } from './styled';
import styles from './styles.module.scss';

const Tooltip = ({
  content,
  children,
  className,
  color = '#0E2576',
  onClick
}) => {
  const [isShow, setIsShow] = React.useState(false);
  const ref = React.useCallback(node => {
    if (node !== null) {
      setRect(node === null || node === void 0 ? void 0 : node.getBoundingClientRect());
    }
  }, []);
  const [leftArrowPosition, setLeftArrowPosition] = React.useState();
  const [translateX, setTranslateX] = React.useState();
  const [rect, setRect] = React.useState();
  const containerRef = React.useCallback(node => {
    if (node !== null && rect) {
      const containerRect = node.getBoundingClientRect();

      if (rect.right > window.outerWidth) {
        const translateX = window.outerWidth - rect.right;
        setTranslateX(translateX);
        setLeftArrowPosition(containerRect.left + (containerRect.right - containerRect.left) / 2 - rect.left - translateX);
        return;
      }

      if (rect.left < 0) {
        const translateX = rect.left;
        setTranslateX(-translateX);
        setLeftArrowPosition(containerRect.left + (containerRect.right - containerRect.left) / 2 - rect.left + translateX);
        return;
      }

      setLeftArrowPosition(containerRect.left + (containerRect.right - containerRect.left) / 2 - rect.left);
    }
  }, [rect]);
  return /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      onClick();
      setIsShow(true);
      setTimeout(() => {
        setIsShow(false);
      }, 2000);
    },
    ref: containerRef,
    className: classNames(styles.tooltip, className)
  }, isShow && /*#__PURE__*/React.createElement(Wrapper, {
    ref: ref,
    arrowLeft: leftArrowPosition,
    translateX: translateX,
    color: color,
    className: classNames(styles['tooltip-content'])
  }, /*#__PURE__*/React.createElement("span", null, content)), children);
};

export default Tooltip;